import React, { Component } from 'react';
import Block from "./block";
import Page from '../page';

export default class Index extends Component {
  render() {
    return (
      <div>
        <Page.Header leftSide={<Page.NewButton title="Add venue collection" name="VenueCollection"/>}>
          Venue Collections
        </Page.Header>

        <Block
          title="Venue Collection"
          path="/admin/venue_collections"
          name="VenueCollection"
        />
      </div>
    );
  }
}
